import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Haku ID:n, nimen tai yrityksen mukaan',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Yhteyden tila',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Yhdistetty',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'Ei yhdistetty',
      },
    },
  },
  columns: {
    name: 'Nimi',
    company: 'Yritys',
    connected: 'Yhdistetty',
    action: 'Toiminto',
    details: 'Tiedot',
    address: 'Osoite',
    status: 'Tila',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Ei määritetty',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Aktiivinen',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Keskeytetty',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Tuntematon',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Poistettu',
  },
};
